<template>
  <div :class="$utils.isMobile() ? 'cpt-structure-m' : 'cpt-structure'">
    <!-- <div></div> -->
    <img class="img" src="../assets/about-bg1-m.png" v-if="$utils.isMobile()" alt="">
    <img class="img" src="../assets/about-bg1.png" v-else alt="">
    <div class="content">
      <div class="name">
        <div class="title-en tit-en" v-if="$i18n.locale == 'zh-CN'">{{ structureData.titleEn }}</div>
        <div class="title tit">{{ structureData.title }}</div>
        <cpt-divider :type="1"></cpt-divider>
      </div>
      <div class="logo">
        <img class="img" src="../assets/about-logo.png" alt="">
        <div class="list">
          <div class="item" v-for="item in structureData.list" :key="item.id">
            <img class="item-logo" :src="item.img" alt="">
            <div :class="$i18n.locale == 'en-US' ? 'name-en' : 'name'">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cptDivider from './cpt-divider.vue';
export default {
  name: 'cpt-structure',
  components: {
    cptDivider
  },
  data() {
    return {
      structureData: this._contentData.structureData
    }
  },

  created() {

  },

  methods: {

  },
}

</script>

<style lang='scss' scoped>
.cpt-structure{
 width: 100%;
 position: relative;
 display: flex;
  .img{
    width: 100%;
  }
  .content{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;
    .name{
      display: flex;
      // justify-content: center;
      flex-direction: column;
      align-items: center;
      .tit-en{
        color: rgba(255, 255, 255, 0.3);
        text-align: center;
      }
      .tit{
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
    }
  }
  .logo{
    position: relative;
    .img{
      width: 100%;
    }
    .list{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      .item{
        width: 30%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 20px;
        .name{
          color: #fff;
          font-size: 20px;
          margin-top: 10px;
        }
        .name-en{
          color: #fff;
          font-size: 18px;
          margin-top: 10px;
          text-align: center;
        }
      }
    }
  }
}
.cpt-structure-m{
//  width: 100%;
 position: relative;
 display: flex;
  .img{
    width: 100%;
  }
  .content{
    position: absolute;
    top: 0;
    left: 0;
    // width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    .name{
      display: flex;
      // justify-content: center;
      flex-direction: column;
      align-items: center;
      .tit-en{
        color: rgba(255, 255, 255, 0.3);
        text-align: center;
      }
      .tit{
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
    }
  }
  .logo{
    position: relative;
    .img{
      width: 100%;
    }
    .list{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      .item{
        width: 30%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 15px;
        .item-logo{
          height: 22px;
        }
        .name{
          color: #fff;
          font-size: 8px;
          margin-top: 5px;
        }
        .name-en{
          color: #fff;
          font-size: 7px;
          margin-top: 5px;
          text-align: center;
        }
      }
    }
  }
}
</style>